import React, { useState } from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { Button, Chip, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { DbMetadataNamingRuleInfos } from "../../../Core/Api/Types/db-metadata-naming-rule-infos";
import AssetTypeChip from "../../Misc/Chips/AssetChip/asset-type-chip";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { assetService } from "../../../Core/Api/services";
export type ModalNamingRuleConfigurationElementProps = {
  onClose?: () => void;
  onConfirm?: () => void;
  namingRule: DbMetadataNamingRuleInfos;
};
export type ModalNamingRuleConfigurationProps = CommonModalProps<ModalNamingRuleConfigurationElementProps>;

const ModalNamingRuleConfiguration = React.forwardRef<any, ModalNamingRuleConfigurationProps>((props, ref) => {
  const { closeModal, onClose, onConfirm, namingRule, ...modalProps } = props;
  const enqueueSnackbar = useCustomSnackbar();
  const theme = useTheme();
  const { t } = useTranslation();

  const handleCancelClick = () => {
    onClose && onClose();
    closeModal();
  };

  const handleGenerateNames = () => {
    assetService.SaveObjectsByType(namingRule.objectType!).then((response) => {
      if (response.success) {
        enqueueSnackbar(response.message ?? t("alert:success.assetRenameLaunched"), "success");
      } else {
        enqueueSnackbar(response.message ?? t("alert:error.assetRenameLaunched"), "error");
      }
    });
  };
  return (
    <Modal
      {...modalProps}
      title={t("button:generateAssetsNames")}
      reference={ref}
      closeModal={handleCancelClick}
      width={500}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="outlined" color="primary" onClick={handleGenerateNames} endIcon={<AutorenewIcon />}>
            {t("button:generateAssetsNames")}
          </Button>
        </Stack>
      }
    >
      <Stack width={"100%"} direction={"column"} spacing={2}>
        <Stack width={"100%"} alignItems={"center"} justifyContent={"space-between"} direction={"row"}>
          <Stack width={"100%"} justifyContent={"flex-start"} display={"flex"} spacing={2} direction={"column"}>
            <Stack justifyContent={"space-between"} width={"100%"} alignItems={"center"} spacing={2} direction={"row"}>
              <Typography variant="body1" color={"text.secondary"}>
                {t("modal:body.namingRuleFor")}
              </Typography>
              <AssetTypeChip type={namingRule.objectType!} />

              {namingRule.contentSubType && <Chip label={namingRule.contentSubType} />}
            </Stack>
            <Stack justifyContent={"space-between"} width={"100%"} alignItems={"center"} spacing={2} direction={"row"}>
              <Typography variant="body1" color={"text.secondary"}>
                {t("common:context")}
              </Typography>
              <Chip label={namingRule.context} />
            </Stack>
            <Stack justifyContent={"space-between"} width={"100%"} alignItems={"center"} spacing={2} direction={"row"}>
              <Typography lineHeight={"24px"} variant="body1" color={"text.secondary"}>
                {t("menu:title.contentSubType")}
              </Typography>
              {namingRule.contentSubType && namingRule.contentSubType !== "" ? (
                <Chip label={namingRule.contentSubType} />
              ) : (
                <Typography lineHeight={"24px"} variant="body2" color={"text.tier"}>
                  {t("modal:body.noSubContent")}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
});

export default ModalNamingRuleConfiguration;
